
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/airtable",
      function () {
        return require("private-next-pages/sources/airtable.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/airtable"])
      });
    }
  